import enums from '../enums/RdsLife.enums';
export default class DriverShift {
  constructor({ id, date, shifts }) {
    this.id = id;
    this.date = date;
    this.shifts = shifts;
    this.tipologia = enums.modelTypes.DRIVER_SHIFT;
  }
}
